<template>
  <div :class="scope.clsPrefix">
    <div class="list-header">
      <div class="search-area">
        <el-input
          size="small"
          placeholder="搜索标题或摘要..."
          v-model="searchText"
          class="search-input">
        </el-input>
        <el-select size="small" v-model="filterCategory" placeholder="全部分类" class="filter-select">
          <el-option label="全部分类" value=""></el-option>
          <el-option label="市场行情" value="market"></el-option>
          <el-option label="政策法规" value="policy"></el-option>
          <el-option label="竞品动态" value="competitor"></el-option>
        </el-select>
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
      </div>
    </div>
    <div class="list-summary">
      <span class="summary-text"><span class="all-report">全部简报</span>（共 {{ total }} 条）</span>
      <!-- ，当前显示 1-{{ reportList.length > 10 ? 10 : reportList.length }} -->
    </div>
    <div v-if="reportList.length > 0" class="report-list">
      <div
        v-for="(item, index) in reportList"
        :key="index"
        class="report-item"
        @click="handleReportClick(item)">
        <div class="report-header">
          <div class="report-header-left">
            <span class="report-tag">{{ item.tag }}</span>
          <!-- <span class="report-status" :class="item.statusClass">{{ item.status }}</span> -->
          </div>
          <div class="report-header-right">
            <div class="report-analysis-btn" @click.stop="handleSmartAnalysis(item)">智能分析</div>
          </div>
        </div>
        <div class="report-title">{{ item.title }}</div>
        <div class="report-desc">{{ item.desc }}</div>
        <div class="report-footer">
          <span class="report-source">{{ item.source }}</span>
          <span class="report-time">|</span>
          <span style="position: relative; bottom: -1px;" class="report-time">{{ item.time }}</span>
        </div>
      </div>
    </div>
    <div v-else class="empty-state">暂无数据</div>
    <!-- <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
import { getJobReportListApi } from '@/api/agentAuth'
export default {
  name: 'EnterpriseList',
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    agentId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-enterprise-list'
      },
      searchText: '',
      filterCategory: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      reportList: []
    }
  },
  created() {
    this.fetchReportList()
  },
  mounted() {},
  methods: {
    async fetchReportList() {
      const params = {}
      if (this.agentId) params.agentId = this.agentId
      if (this.searchText) params.keyword = this.searchText
      if (this.filterCategory) {
        params.reportType = this.filterCategory
      }
      try {
        const res = await getJobReportListApi(params)
        if (res && res.data && res.data.length > 0) {
          this.reportList = this.transformData(res.data)
          this.total = res.data.length
        } else {
          this.reportList = []
          this.total = 0
        }
      } catch (error) {
        console.error('获取企业战情室报告列表失败:', error)
        this.reportList = []
        this.total = 0
      }
    },
    transformData(data) {
      return data.map(item => ({
        id: item.id,
        tag: this.getCategoryText(item.reportType),
        status: this.getImpactText(item.impactLevel),
        statusClass: this.getImpactClass(item.impactLevel),
        title: item.title,
        desc: item.content || item.summary,
        source: item.agentName || '经营分析系统',
        time: this.formatTime(item.updateTime || item.createTime),
        reportType: item.reportType,
        category: item.category
      }))
    },
    getCategoryText(type) {
      const map = { market: '市场行情', policy: '政策法规', competitor: '竞品动态' }
      return map[type] || '市场行情'
    },
    getImpactText(level) {
      if (level >= 5) return '负向'
      return '正向'
    },
    getImpactClass(level) {
      if (level >= 5) return 'status-negative'
      return 'status-positive'
    },
    formatTime(val) {
      if (!val) return ''
      const d = new Date(val)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    handleSearch() {
      this.fetchReportList()
    },
    handleReportClick(item) {
      const index = this.reportList.findIndex(i => i.id === item.id)
      this.$emit('open-detail', {
        item: item,
        source: 'list',
        index: index
      })
    },
    handleSmartAnalysis(item) {
      this.$emit('smart-analysis', {
        type: 'enterpriseWarRoom',
        content: item.desc || '请深度分析今日内部经营简报'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.all-report {
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  margin-right: 4px;
}
$class-prefix: "rvc-cosmoplat-workspace-enterprise-list";
.#{$class-prefix} {
  height: 100%;
  padding-top: 8px;
  padding-bottom: 24px;
  // padding-top: 0;
  // background: #fff;
  border-radius: 8px;
  min-height: 500px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.list-header {
  margin-bottom: 16px;
}
.search-area {
  display: flex;
  align-items: center;
  gap: 12px;
}
.search-input {
  flex: 1;
  // width: 280px;
}
.filter-select {
  width: 120px;
}
.list-summary {
  margin-bottom: 16px;
}
.summary-text {
  padding-left: 20px;
  font-size: 14px;
  color: #999;
  font-family: PingFangSC-Regular;
}
.report-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
}
.report-list::-webkit-scrollbar {
  width: 4px;
}
.report-list::-webkit-scrollbar-track {
  background: transparent;
}
.report-list::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}
.report-item {
  padding: 16px 32px;
  background: #fff;
  border-radius: 8px;
  // border: 1px solid #E8ECF0;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    // border-color: #4A5FF3;
    // background: #F5F7FF;
  }
}
.report-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 12px;
}
.report-header-left {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}
.report-header-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  // gap: 12px;
  .report-analysis-btn {
    width: 64px;
    height: 24px;
    background-image: linear-gradient(270deg, #4A5FF3 0%, #4E86FF 100%);
    border-radius: 12px;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.report-tag {
  // padding: 2px 10px;
  // background: #E8F5E9;
  color: #4A5FF3;
  padding: 0 12px;
  font-size: 12px;
  // border-radius: 4px;
  font-family: PingFangSC-Regular;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  border: 1px solid #4A5FF3;
  border-radius: 12px;
}
.report-status {
  height: 24px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border-radius: 12px;
  font-family: PingFangSC-Regular;
  &.status-positive {
    background: #E8F5E9;
    color: #4CAF50;
  }
  &.status-negative {
    background: #FFEBEE;
    color: #F44336;
  }
}
.report-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  font-family: PingFangSC-Medium;
}
.report-desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
  font-family: PingFangSC-Regular;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.report-footer {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}
.report-source {
  font-size: 12px;
  color: #999;
  font-family: PingFangSC-Regular;
}
.report-time {
  font-size: 12px;
  color: #999;
  // vertical-align: baseline;
  vertical-align: text-bottom;
  font-family: PingFangSC-Regular;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
  border-top: 1px solid #F0F0F0;
}
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #999;
  font-size: 14px;
}
</style>
